/* prettier-ignore */
import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { LicenseInfo } from "@mui/x-license";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@utils";

import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import React from "react";
import ReactDOM from "react-dom/client";
export type { RawEditorHandle } from "src/components/DocViewer/components/markdownDocViewer/rawEditor/RawEditor";
import App from "./App";
import { Snackbar } from "./components/Snackbar/Snackbar";
import { SnackbarProvider } from "./components/Snackbar/useSnackbar";
import { theme } from "./config";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./sentry";
import { StoreContext, rootStore } from "./stores";

// scan({
//   enabled: import.meta.env.MODE === "development",
// });

LicenseInfo.setLicenseKey(window._env_.MUI_LICENSE_KEY);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

posthog.init(window._env_.PUBLIC_POSTHOG_KEY!, {
  api_host: window._env_.PUBLIC_POSTHOG_API_HOST!,
  ui_host: window._env_.PUBLIC_POSTHOG_UI_HOST!,
  disable_session_recording: process.env.NODE_ENV !== "production",
});

const MainContent = () => (
  <StoreContext.Provider value={rootStore}>
    <Snackbar />
    <App />
  </StoreContext.Provider>
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Add this and import it to enable React Query Devtools */}
      {/* import { ReactQueryDevtools } from "@tanstack/react-query-devtools"; */}
      {/* <ReactQueryDevtools initialIsOpen={false}  /> */}

      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <SnackbarProvider>
            <PostHogProvider client={posthog}>
              <MainContent />
            </PostHogProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals((metric) => console.info(metric)))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
